import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { hideAssignToUserModal } from './assignToUserModal';
import { getForms } from './getForms';

export const ASSIGN_TO_USER_REQUEST = 'ASSIGN_TO_USER_REQUEST';
export const ASSIGN_TO_USER_SUCCESS = 'ASSIGN_TO_USER_SUCCESS';
export const ASSIGN_TO_USER_ERROR = 'ASSIGN_TO_USER_ERROR';

function requestAssignToUser() {
  return {
    type: ASSIGN_TO_USER_REQUEST,
  };
}

function receiveAssignToUser() {
  return {
    type: ASSIGN_TO_USER_SUCCESS
  };
}

function rejectAssignToUser() {
  return {
    type: ASSIGN_TO_USER_ERROR
  };
}

export function assignFormsToUser(formIdlist, user, currentPageNumber, currentPageSize) {
  return (dispatch) => {
    dispatch(requestAssignToUser());

    const promise = () => ApiService
      .assignFormToUser(formIdlist, user.id)
      .then((response) => {
        dispatch(hideAssignToUserModal());
        dispatch(receiveAssignToUser(response.data));
        toastr.success('', 'The user has been successfully assigned');
        return dispatch(getForms(currentPageNumber, currentPageSize));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectAssignToUser, true));
        }
      });
    return promise();
  };
}

export function assignFormsToUserWithCallback(formIdlist, user, callback) {
  return (dispatch) => {
    dispatch(requestAssignToUser());

    const promise = () => ApiService
      .assignFormToUser(formIdlist, user.id)
      .then((response) => {
        dispatch(hideAssignToUserModal());
        dispatch(receiveAssignToUser(response.data));
        toastr.success('', 'The user has been successfully assigned');
        callback();
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectAssignToUser, true));
        }
      });
    return promise();
  };
}
